import React from "react";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Footer from "../../components/Footer";



const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://metaguise.com/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Terms & Conditions",
      "item": "https://metaguise.com/terms-conditions/"
    }
  ]
};

function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
}, []);
  // useEffect(() => {
  //   AOS.init({
  //     duration: 2000, // Animation duration
  //   });
  // }, []);

  return (
    <>
      <Helmet>
        <title>Terms and Conditions | Metaguise</title>
        <meta
          name="description"
          content="Read Metaguise's Terms and Conditions covering website use, intellectual property rights, and liability for www.metaguise.com."
        />
        <link rel="canonical" href="https://metaguise.com/terms-conditions/" />

        {/* Robots */}
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Terms and Conditions | Metaguise" />
        <meta
          property="og:description"
          content="Read Metaguise's Terms and Conditions covering website use, intellectual property rights, and liability for www.metaguise.com."
        />
        <meta property="og:url" content="https://metaguise.com/terms-conditions/" />
        <meta property="og:site_name" content="Metaguise" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Terms and Conditions | Metaguise" />
        <meta
          name="twitter:description"
          content="Read Metaguise's Terms and Conditions covering website use, intellectual property rights, and liability for www.metaguise.com."
        />

        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>

    <div className="container-fluid ">

      <div className="content-desk">
        {/* <main> */}
        <div className="container-fluid my-5">
        <div className="container mx-auto p-6 privacy-text">
      <h1 className="text-3xl font-semibold my-4">Terms and Conditions</h1>
      <p>Welcome to Metaguise!</p>
      <p>
        These terms and conditions outline the rules and regulations for the use
        of Metaguise’s Website, located at <a href="http://www.metaguise.com/" target="_blank" rel="noopener noreferrer">www.metaguise.com</a>
      </p>
      <p>
        By accessing this website we assume you accept these terms and
        conditions. Do not continue to use Metaguise if you do not agree to take
        all of the terms and conditions stated on this page.
      </p>
      <h2 className="text-2xl font-semibold mt-4">Cookies</h2>
      <p>
        We employ the use of cookies. By accessing Metaguise, you agreed to use
        cookies in agreement with Metaguise’s Privacy Policy.
      </p>
      <h2 className="text-2xl font-semibold mt-4">License</h2>
      <p>
        Unless otherwise stated, Metaguise and/or its licensors own the
        intellectual property rights for all material on Metaguise. All
        intellectual property rights are reserved. You may access this from
        Metaguise for your own personal use, subject to restrictions set in
        these terms and conditions.
      </p>
      <ul className="list-disc ml-6">
        <li>Republish material from Metaguise</li>
        <li>Sell, rent, or sub-license material from Metaguise</li>
        <li>Reproduce, duplicate, or copy material from Metaguise</li>
        <li>Redistribute content from Metaguise</li>
      </ul>
      <h2 className="text-2xl font-semibold mt-4">Disclaimer</h2>
      <p>
        To the maximum extent permitted by applicable law, we exclude all
        representations, warranties, and conditions relating to our website and
        the use of this website. Nothing in this disclaimer will:
      </p>
      <ul className="list-disc ml-6">
        <li>Limit or exclude our or your liability for death or personal injury</li>
        <li>Limit or exclude our or your liability for fraud or fraudulent misrepresentation</li>
        <li>
          Limit any of our or your liabilities in any way that is not permitted
          under applicable law
        </li>
      </ul>
      <p className="mt-4">
        As long as the website and the information and services on the website
        are provided free of charge, we will not be liable for any loss or
        damage of any nature.
      </p>
    </div>
          
        </div>
      </div>
      <Footer />
    </div>
    </>
  );
}

export default Terms;